import {
  AIStrength,
  AIStyle,
  independentAISeed,
  type ITableAIProfile,
  type TAIStrength,
} from './table-ai';

export const TableId = {
  Beginner: 'beginner-v1',
  Intermediate: 'intermediate-v1',
  Expert: 'expert-v1',
} as const;
export type TTableId = (typeof TableId)[keyof typeof TableId];
export interface ITableDefinition {
  readonly id: TTableId;
  readonly name: string;
  readonly description: string;
  readonly strength: TAIStrength;
}
export const TABLE_CATALOG: readonly ITableDefinition[] = [
  {
    id: TableId.Beginner,
    name: '新手桌',
    description: '熟悉牌路\n輕鬆開局',
    strength: AIStrength.Low,
  },
  {
    id: TableId.Intermediate,
    name: '進階桌',
    description: '攻守之間\n切磋牌技',
    strength: AIStrength.Medium,
  },
  {
    id: TableId.Expert,
    name: '高手桌',
    description: '細算每一手\n迎接挑戰',
    strength: AIStrength.High,
  },
];
export const findTable = (id: unknown): ITableDefinition | undefined =>
  TABLE_CATALOG.find((table) => table.id === id);

/** 只在正式開新圈時產生決策亂數，瀏覽或返回選桌畫面不寫入存檔。 */
export const createSelectedTableProfile = (
  id: TTableId,
  seed: () => number = independentAISeed
): ITableAIProfile => {
  const table = findTable(id);
  if (!table) throw new Error('找不到指定牌桌');
  return {
    tableId: table.id,
    configVersion: 1,
    strategyVersion: 1,
    seats: [
      { strength: AIStrength.Medium, style: AIStyle.Balanced, seed: seed() },
      { strength: table.strength, style: AIStyle.Attack, seed: seed() },
      { strength: table.strength, style: AIStyle.Balanced, seed: seed() },
      { strength: table.strength, style: AIStyle.Cautious, seed: seed() },
    ],
  };
};
